module.exports = __webpack_public_path__ + "fa-solid-900.ttf?130c802cd676d12f9610f918cac596fd";